import { post } from '@/util/http'
// 获取人员信息
export const getApprovalUsers = params => post(`/sum/user/selectApprovalPage`, params)
// 保存未通过信息
export const saveNotPass = params => post(`/sum/user/updateNotPass`, params)
// 保存通过信息
export const savePass = params => post(`/sum/user/updatePass`, params)
